<sk-modal-content [title]="'label.dms.ImportFolderStructureFromFile' | translate | uppercase"
                  confirmByKeypress
                  (confirmed)="uploadZipFolder()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    @if (!uploader?.queue.length) {
      <div
        class="wrapper-upload-form"
        ng2FileDrop
        [uploader]="uploader"
      >
        <div class="well my-drop-zone one-task-drop-zone">
          <div class="d-flex flex-column">
            <input class="d-none" type="file" #fileInput ng2FileSelect [uploader]="uploader" [accept]="acceptMimeTypes" />

            <div class="d-flex align-items-center">
              <span class="fw-normal me-2">{{ 'label.DropFileHereOr' | translate }}</span>
              <sk-button
                [appearance]="'outlined'"
                [color]="'primary'"
                (click)="fileInput.click()"
                [label]="'label.ClickToUpload' | translate"
                data-test="import-zip-folder-modal_upload-button"
              >
                <ng-template buttonPrefix>
                  <i class="fa-fw fas fa-upload"></i>
                </ng-template>
              </sk-button>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <table class="table">
        <thead>
        <tr>
          <th></th>
          <th>{{ 'label.Title' | translate }}</th>
          @if (uploader.options?.isHTML5) {
            <th>{{ 'label.Size' | translate }}</th>
            <th>{{ 'label.Progress' | translate }}</th>
          }
          <th>{{ 'label.Status' | translate }}</th>
          <th>{{ 'label.Actions' | translate }}</th>
        </tr>
        </thead>
        <tbody>
          @for (item of uploader.queue; track item.file?.name; let i = $index) {
            <tr [class.error-uploading-item]="item.isError">
              <td>{{ i + 1 }}</td>
              <td><strong>{{ item.file?.name }}</strong></td>
              @if (uploader.options?.isHTML5) {
                <td nowrap>{{ item.file?.size | filesize }}</td>
                <td nowrap>
                  <div class="progress">
                    <div class="progress-bar progress-bar-success"
                      role="progressbar"
                      [style.width]="item.progress + '%'"
                    ></div>
                  </div>
                </td>
              }
              <td>
                <span>
                  <i class="fas"
                    [class.fa-ban]="item.isCancel"
                    [class.fa-check-circle.check-circle-icon]="item.isSuccess"
                    [class.fa-exclamation-triangle.exclamation-triangle-icon]="item.isError"
                    [matTooltip]="getItemStatusTooltip(item)"
                    [matTooltipDisabled]="item.isCancel"
                  ></i>
                </span>
              </td>
              <td nowrap>
                <sk-button
                  [appearance]="'icon'"
                  [attr.data-test]="'import-zip-folder-modal_remove-' + item.file?.name"
                  (click)="item.remove()"
                  [disabled]="item.isUploading"
                >
                  <i class="icon far fa-trash-alt"></i>
                </sk-button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <sk-text
        [label]="'label.Description' | translate"
        data-test="import-zip-folder-modal_comment"
        [formControl]="folderCommentControl"
      ></sk-text>
    }
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button
      [color]="'primary'"
      [label]="'label.Upload' | translate"
      (click)="uploadZipFolder()"
      data-test="modal-footer-confirm-button">
      <ng-template buttonPrefix>
        <i class="fas fa-upload"></i>
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
